import { render, staticRenderFns } from "./TaxRow.vue?vue&type=template&id=93dbeb10&"
import script from "./TaxRow.vue?vue&type=script&lang=js&"
export * from "./TaxRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports